import React, { useRef, useState } from "react"

import * as styles from "./search-form.module.scss"
import * as inputsStyles from "../layout/inputs.module.scss"
import Input from "../layout/form/input"

type RenderProps = {
  query: string
  buttonLabel: string
  searchLabel: string
  onChange: (value: string) => void
  locale: string
  defaultLocale: string
}

const SearchForm: React.FC<RenderProps> = ({ query, buttonLabel, searchLabel, onChange, locale, defaultLocale }) => {
  const [value, setValue] = useState(query)
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleSubmit = event => {
    onChange(value)
    buttonRef.current.blur()
    event.preventDefault()
  }

  return (
    <form
      action={locale === defaultLocale ? `/search` : `/${locale}/search`}
      method="get"
      className={styles.form}
      onSubmit={handleSubmit}
      role="search"
    >
      <label htmlFor="search-query" className="sr-only">
        {searchLabel}
      </label>
      <Input
        id="search-query"
        type="search"
        name="query"
        value={value}
        placeholder={searchLabel}
        title={searchLabel}
        onChange={setValue}
        className={styles.searchInput}
      />
      <button type="submit" className={`${inputsStyles.primaryButton} ${styles.searchButton}`} ref={buttonRef}>
        {buttonLabel}
      </button>
    </form>
  )
}

export default SearchForm
